export default "__VITE_ASSET__b27c87a2__"